/**
 * TypeScript utilities for shader manipulation.
 * @module
 */

export type ShaderProgramLike = {
  vertexShader: string;
  fragmentShader: string;
};

/**
 * Replaces a pattern in a shader string, throwing an error if the pattern is not found.
 * This prevents silent failures when Three.js shader structure changes between versions.
 * @param shader The shader source code
 * @param search The pattern to search for (string or RegExp)
 * @param replacement The replacement string
 * @param context A description of where this replacement is happening (used in error messages)
 * @returns The modified shader string
 */
export function safeShaderReplace(
  shader: string,
  search: string | RegExp,
  replacement: string,
  context: string,
): string {
  const found = typeof search === "string" ? shader.includes(search) : search.test(shader);

  if (!found) {
    console.error(`Shader injection failed in ${context}. Full shader source:\n${shader}`);
    throw new Error(
      `Shader injection failed: pattern ${search} not found in ${context}. ` +
        `This may indicate a Three.js version incompatibility. See console for full shader source.`,
    );
  }

  return shader.replace(search, replacement);
}
